export default __webpack_public_path__ + "static/media/Button_Add_Sepia.085e6e22.svg";